import { BaseVm } from '@/mobxTools'
import { BindPhoneDialogProps } from './BindPhoneDialog'
import { observable } from 'mobx'
import { userService } from '@/services/userService'

export default class BindPhoneDialogVm extends BaseVm<BindPhoneDialogProps> {
  props!: BindPhoneDialogProps

  @observable
  public phoneNumber = ''

  public bindPhone() {
    userService.bindPhone({ phoneNumber: this.phoneNumber })
  }
}
